import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import denormalize from 'json-api-denormalizer'
import * as actions from './actions'

const includedModuleResources = [
  'sequences',
  'sequences.quests',
  'quests',
  'sandbox-activities'
]
export { includedModuleResources }

class ModuleFetchContainer extends Component {
  componentDidMount() { this.fetchModules() }

  fetchModules = ()=> {
    const { dispatch } = this.props
    const fetchPath = `/modules?include=${includedModuleResources.join(',')}`
    actions.fetchModules(dispatch, fetchPath)
  }

  childProps = ()=>{
    const { isFetching, fetchError, collection, ...rest } = this.props
    return {
      moduleProps: { isFetching, fetchError, collection }, ...rest
    }
  }

  render() {
    return(
      React.cloneElement(React.Children.only(this.props.children), this.childProps())
    );
  }
}

const mapStateToProps = state =>({
  ...state.modules,
  collection: denormalize(state.api).modules || {}
})

export default connect(mapStateToProps)(ModuleFetchContainer);
